export enum DashboardNewsWidgetBlock {
  Root = 'DashboardNewsWidget',
}

export enum DashboardNewsWidgetElement {
  Filter = 'filter',
}
